import { render, staticRenderFns } from "./TreasureDetailView.vue?vue&type=template&id=7e0b7596&scoped=true"
import script from "./TreasureDetailView.vue?vue&type=script&lang=js"
export * from "./TreasureDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b7596",
  null
  
)

export default component.exports